import React from 'react';
import Label from '~/componentes/CustomForm/Label';
import { Select } from '~/componentes/CustomForm';
import { useState } from 'react';
import { useEffect } from 'react';
import api from '~/services/api';

function PrioridadeListColor({ defaultData, setter, name }) {
  const [prioridades, setPrioridades] = useState([]);
  const [prioridade, setPrioridade] = useState(
    defaultData ? defaultData : { cor: undefined, id: 0, titulo: '' },
  );

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/gerencia/prioridades', { params: { ativo: 1 } })
      .then(r => {
        setPrioridades(r?.data || []);
        if (defaultData?.id && r?.data) {
          const found = r.data.find(p => p.id === defaultData.id);
          if (found) {
            setPrioridade(found);
          }
        }
      });
  }, []);

  useEffect(() => {
    setter(prioridade);
  }, [prioridade, setter]);

  return (
    <Label title="Prioridade *" className="no-margin" row={true}>
      <Select
        name={name || 'idPrioridade'}
        required="true"
        isString
        list={{ list: prioridades, value: 'id', label: 'titulo' }}
        firstOption
        defaultValue={defaultData?.id}
        onChange={e => {
          const v = e.currentTarget.value;
          const selectedPrioridade = prioridades?.find(p => p?.id == parseInt(v));
          if (selectedPrioridade) {
            setPrioridade(selectedPrioridade);
          } else {
            setPrioridade({ cor: undefined, id: 0, titulo: '' });
          }
        }}
      />
    </Label>
  );
}

export default PrioridadeListColor;
